import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tuke-quality-evaluation';
  private readonly baseDocumentTitle = 'TUKE hodnotenie kvality';

  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'sk']);
    translate.setDefaultLang('sk');
    translate.use(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'sk');
    document.title = environment.development
      ? `TEST ${this.baseDocumentTitle}`
      : this.baseDocumentTitle;
  }
}
